import { createReducer, createStandardAction } from "typesafe-actions";
import { SortState } from "store/filters";
import { TrialUser } from "../useTrialUsers";

export type TrialUserListState = {
  dataLoaded: boolean;
  selectedItems: string[];
  sort: SortState;
  searchTerm?: string;
  trialUserCount: number;
  trialUsers: TrialUser[];
  visibleTrialUsers: Set<string>;
};

export const syncVisibleTrialUsers = (
  visibleTrialUsers: Set<string>,
  trialUsers: TrialUser[]
) => {
  let newVisibleTrialUsers;
  if (visibleTrialUsers.size > 0 && trialUsers.length > 0) {
    newVisibleTrialUsers = new Set(
      trialUsers
        .filter(trialUser => visibleTrialUsers.has(trialUser.id))
        .map(trialUser => trialUser.id)
    );
  } else {
    newVisibleTrialUsers = new Set();
  }
  return newVisibleTrialUsers;
};

export const updateDataLoaded = createStandardAction("UpdateDataLoaded")<
  TrialUserListState["dataLoaded"]
>();

export const updateSelectedItems = createStandardAction("UpdateSelectedItems")<
  TrialUserListState["selectedItems"]
>();

export const updateSort = createStandardAction("UpdateSort")<
  TrialUserListState["sort"]
>();

export const updateSearch = createStandardAction("UpdateSearch")<
  TrialUserListState["searchTerm"]
>();

export const updatePageInfo = createStandardAction("UpdatePageInfo")<
  Pick<TrialUserListState, "trialUserCount" | "trialUsers">
>();

export const updateVisibleTrialUsers = createStandardAction(
  "UpdateVisibleTrialUsers"
)<TrialUserListState["visibleTrialUsers"]>();

export const defaultTrialUserListState: TrialUserListState = {
  dataLoaded: false,
  selectedItems: [],
  sort: {
    field: "email",
    direction: "ASC"
  },
  searchTerm: "",
  trialUserCount: 0,
  trialUsers: [],
  visibleTrialUsers: new Set()
};

export const TrialUserListReducer = createReducer(defaultTrialUserListState)
  .handleAction(updateDataLoaded, (state, action) => ({
    ...state,
    dataLoaded: action.payload
  }))
  .handleAction(updateSelectedItems, (state, action) => ({
    ...state,
    selectedItems: action.payload
  }))
  .handleAction(updateSort, (state, action) => ({
    ...state,
    sort: action.payload
  }))
  .handleAction(updateSearch, (state, action) => ({
    ...state,
    searchTerm: action.payload
  }))
  .handleAction(updatePageInfo, (state, action) => ({
    ...state,
    visibleTrialUsers: syncVisibleTrialUsers(
      state.visibleTrialUsers,
      action.payload.trialUsers
    ),
    ...action.payload
  }))
  .handleAction(updateVisibleTrialUsers, (state, action) => ({
    ...state,
    visibleTrialUsers: action.payload
  }));
